import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";

function TagsPage() {
  const navigate = useNavigate();
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTags = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/V2/tags/all-tags`);
      console.log("API Response:", response.data);
      setTags(response.data.data || []);
      setLoading(false);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Failed to fetch tags from the server.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading(false);
      console.error("Error fetching tags:", error);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  const handleClick = (tagId) => {
    navigate(`/dashboard/17-tags/edit-tag/${tagId}`);
  };

  const deleteTag = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This Tag will be permanently deleted!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        await axios.delete(`${process.env.REACT_APP_API_URL}/api/V2/tags/tag/${id}`);
        setTags((prev) => prev.filter((tag) => tag._id !== id));

        Swal.fire("Deleted!", "The tag has been deleted.", "success");
      }
    } catch (error) {
      console.error("Error deleting tag:", error);

      Swal.fire("Error!", "Failed to delete the tag. Please try again.", "error");
    }
  };

  const tagTableData = {
    columns: [
      { Header: "name", accessor: "name", align: "left" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],
    rows: Array.isArray(tags)
      ? tags.map((tag) => ({
          name: tag.name,
          actions: (
            <MDBox display="flex" justifyContent="center" gap={1}>
              <Tooltip title="Edit Tag">
                <IconButton color="info" variant="contained" onClick={() => handleClick(tag._id)}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Tag">
                <IconButton color="error" onClick={() => deleteTag(tag._id)}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </MDBox>
          ),
        }))
      : [],
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        mx={2}
        mt={-1}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          All Tags
        </MDTypography>
      </MDBox>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox pt={3}>
                <DataTable
                  table={tagTableData}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TagsPage;
